import gql from 'graphql-tag';

/** The unavailable time ranges of several rooms in one request (50 at most). */
export const getReservablesAvailabilityQuery = gql(/* GraphQL */ `
  query getReservablesAvailability(
    $contentIds: [UUID!]!
    $start: DateTime!
    $end: DateTime!
  ) {
    contentsFeatureReservableAvailability(
      contentIds: $contentIds
      start: $start
      end: $end
    ) {
      contentId
      unavailable {
        startDate
        endDate
        eventType
      }
    }
  }
`);
